var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "code-tag-editor"
  }, [_c('v-tooltip', {
    attrs: {
      "top": ""
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function (_ref) {
        var on = _ref.on,
          attrs = _ref.attrs;
        return [_c('v-btn', _vm._g(_vm._b({
          attrs: {
            "disabled": _vm.isDisabled,
            "color": "primary",
            "icon": ""
          },
          on: {
            "click": _vm.openDialog
          }
        }, 'v-btn', attrs, false), on), [_c('v-icon', [_vm._v("mdi-tag-multiple-outline")])], 1)];
      }
    }])
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('edit_tags')))])]), _c('v-dialog', {
    attrs: {
      "width": "600",
      "scrollable": "",
      "persistent": ""
    },
    model: {
      value: _vm.dialog,
      callback: function ($$v) {
        _vm.dialog = $$v;
      },
      expression: "dialog"
    }
  }, [_vm.mode == 'edit' ? _c('v-card', {
    staticClass: "edit-tag-dialog"
  }, [_c('v-card-title', [_vm._v(" " + _vm._s(_vm.$t('edit_tags')) + " "), _c('v-spacer'), _c('v-btn', {
    attrs: {
      "disabled": _vm.hasLimit('tags') && _vm.filteredTags.length >= _vm.getLimit('tags'),
      "color": "primary",
      "text": ""
    },
    on: {
      "click": function ($event) {
        _vm.mode = 'new';
      }
    }
  }, [_c('v-icon', {
    staticClass: "mr-2"
  }, [_vm._v("mdi-tag-plus-outline")]), _vm._v(_vm._s(_vm.$t('new_tag')))], 1)], 1), _vm.filteredTags.length ? _c('v-card-text', {
    staticClass: "py-5"
  }, [_vm.codes.length == 1 || !_vm.showEditRadio ? _c('div', {
    staticClass: "pl-2 pb-4 tag-hint font-weight-light"
  }, [_vm._v(" " + _vm._s(_vm.$t('empty_tag_hint')) + " ")]) : _vm._e(), _vm.codes.length > 1 && _vm.showEditRadio ? _c('div', {
    staticClass: "pl-2 pb-4 tag-hint font-weight-light"
  }, [_vm._v(" " + _vm._s(_vm.$t('bulk_tag_edit_hint')) + " "), _c('v-radio-group', {
    staticClass: "radio-ctn font-weight-medium",
    model: {
      value: _vm.updateMode,
      callback: function ($$v) {
        _vm.updateMode = $$v;
      },
      expression: "updateMode"
    }
  }, [_c('v-radio', {
    attrs: {
      "value": "standard",
      "label": _vm.$t('ignore_empty_tags')
    }
  }), _c('v-radio', {
    attrs: {
      "value": "clear-empty-tags",
      "label": _vm.$t('delete_empty_tags')
    }
  })], 1)], 1) : _vm._e(), _c('div', {
    staticClass: "d-flex tag-header font-weight-bold mx-3"
  }, [_c('div', {
    staticClass: "name"
  }, [_vm._v(_vm._s(_vm.$t('tag_name')))]), _c('div', [_vm._v(_vm._s(_vm.$t('tag_value')))]), _c('v-spacer'), _vm.hasLimit('tags') ? _c('div', [_vm._v(_vm._s(_vm.filteredTags.length) + "/" + _vm._s(_vm.getLimit('tags')))]) : _vm._e()], 1), _vm._l(_vm.filteredTags, function (tag) {
    return _c('tag-input', {
      key: tag.key,
      staticClass: "ma-2",
      attrs: {
        "tag-value": _vm.codeTags[tag.key],
        "date-value": _vm.parsedDateValue(tag.key),
        "date-error-message": _vm.dateFieldsErrors[tag.key],
        "label": tag.key,
        "type": tag.type,
        "mode": _vm.mode,
        "rules": _vm.editRules
      },
      on: {
        "update:tagValue": function ($event) {
          return _vm.$set(_vm.codeTags, tag.key, $event);
        },
        "update:tag-value": function ($event) {
          return _vm.$set(_vm.codeTags, tag.key, $event);
        },
        "delete-tag": function ($event) {
          return _vm.deleteTag(tag);
        }
      }
    });
  })], 2) : _vm._e(), !_vm.filteredTags.length ? _c('v-card-text', {
    staticClass: "py-5"
  }, [_vm._v(" " + _vm._s(_vm.$t('tags_empty_state')) + " ")]) : _vm._e(), _vm.saveTagsErrors.length ? _c('v-card-text', {
    staticClass: "red--text text-center"
  }, _vm._l(_vm.saveTagsErrors, function (error) {
    return _c('div', {
      key: error
    }, [_vm._v(_vm._s(error))]);
  }), 0) : _vm._e(), _c('v-card-actions', [_c('v-spacer'), _c('v-btn', {
    attrs: {
      "text": ""
    },
    on: {
      "click": _vm.close
    }
  }, [_vm._v(_vm._s(_vm.$t('close')))]), !_vm.filteredTags.length && !_vm.tagsToDelete.length ? _c('v-btn', {
    attrs: {
      "text": "",
      "color": "primary",
      "loading": _vm.saving
    },
    on: {
      "click": function ($event) {
        _vm.mode = 'new';
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('ok')))]) : _vm._e(), _vm.filteredTags.length || _vm.tagsToDelete.length ? _c('v-btn', {
    attrs: {
      "text": "",
      "color": "primary",
      "loading": _vm.saving
    },
    on: {
      "click": _vm.saveTags
    }
  }, [_vm._v(_vm._s(_vm.$t('save')))]) : _vm._e()], 1)], 1) : _vm._e(), _vm.mode == 'new' ? _c('v-card', {
    staticClass: "edit-tag-dialog"
  }, [_c('v-card-title', [_vm._v(" " + _vm._s(_vm.$t('new_tag')) + " ")]), _c('v-card-text', {
    staticClass: "py-5"
  }, [_c('div', {
    staticClass: "pb-5"
  }, [_c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.$t('new_tag_hint'))
    }
  })]), _c('v-form', {
    ref: "form",
    model: {
      value: _vm.valid,
      callback: function ($$v) {
        _vm.valid = $$v;
      },
      expression: "valid"
    }
  }, [_c('div', {
    staticClass: "tag-input d-flex"
  }, [_c('div', {
    staticClass: "label font-weight-bold pt-2"
  }, [_vm._v(_vm._s(_vm.$t('tag_name')))]), _c('v-text-field', {
    attrs: {
      "counter": 50,
      "placeholder": _vm.$t('tag_name_example'),
      "dense": "",
      "single-line": "",
      "outlined": "",
      "rules": _vm.newRules
    },
    model: {
      value: _vm.form.key,
      callback: function ($$v) {
        _vm.$set(_vm.form, "key", $$v);
      },
      expression: "form.key"
    }
  })], 1), _c('div', {
    staticClass: "errors-ctn"
  }, _vm._l(_vm.createTagErrors, function (error) {
    return _c('div', {
      key: error
    }, [_vm._v(_vm._s(error))]);
  }), 0)])], 1), _c('v-card-actions', [_c('v-spacer'), _c('v-btn', {
    attrs: {
      "text": ""
    },
    on: {
      "click": _vm.goToEdit
    }
  }, [_vm._v(_vm._s(_vm.$t('back')))]), _c('v-btn', {
    attrs: {
      "text": "",
      "color": "primary",
      "loading": _vm.saving
    },
    on: {
      "click": _vm.createTag
    }
  }, [_vm._v(_vm._s(_vm.$t('create')))])], 1)], 1) : _vm._e()], 1)], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }